/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.28.0
 */

import { SagaIterator } from 'redux-saga';
import { all, put, select, take, takeEvery } from 'redux-saga/effects';

import {
    onboardingInitStartAction,
    onboardingPageReadyForStartAction,
} from '@/main/modules/onboarding/onboardingActions';
import { ONBOARDING_INIT_SUCCESS } from '@/main/modules/onboarding/onboardingConstants';
import { EOnboardingPage } from '@/main/modules/onboarding/types/onboardingTypes';
import { FeatureNameEnum } from '@/main/modules/role/constants/guard/guardConstants';

import { makeSelectIsFeatureWithVersionEnabled } from '../PageAuth/selectors/authSelectors';
import { HISTORY_INQUIRY_INIT_ONBOARDING } from './constants';

export function* pagaHistoryInquiryInitSaga(): SagaIterator {
    const isOnboardingFeatureEnabled = yield select(
        makeSelectIsFeatureWithVersionEnabled(FeatureNameEnum.OTHER_INQUIRIES, 1, true),
    );

    if (isOnboardingFeatureEnabled) {
        yield put(onboardingInitStartAction({ page: EOnboardingPage.inquiries }));
        yield take(ONBOARDING_INIT_SUCCESS);

        yield put(onboardingPageReadyForStartAction());
    }
}

export function* pagaHistoryInquirySagas(): SagaIterator {
    yield all([takeEvery(HISTORY_INQUIRY_INIT_ONBOARDING, pagaHistoryInquiryInitSaga)]);
}
